import React from 'react';
import {Switch} from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MmamaEntityUpdate from './mmama-entity-update';
import MmamaEntityMasterUpdate from './mmama-entity-master-update';
import MmamaEntity from "app/entities/mmama-entity/mmama-entity";

const Routes = ({match}) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/create`} component={MmamaEntityUpdate}/>
      <ErrorBoundaryRoute exact path={`${match.url}/master/:id/edit`} component={MmamaEntityMasterUpdate}/>
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MmamaEntityUpdate}/>
      <ErrorBoundaryRoute path={match.url} component={MmamaEntity}/>
    </Switch>
  </>
);

export default Routes;
